var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.desc},[_c('div',{class:_vm._.content,domProps:{"innerHTML":_vm._s(_vm.goodsData.commodityDetail)},on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }